import { get } from 'lodash';

const root = state => get(state, 'TruckRouteState.tabSettingsState');

export const getSelectedTab = state => get(root(state), 'selectedTab', '');



// WEBPACK FOOTER //
// ./src/pages/inventory/truckroutes/state/settings/selectors.js